/** Vitória/ES — onde ficam as 3 estações reais hoje (CLAUDE.md §2.2). Usado só
 * como centro/zoom de segurança antes do primeiro fitBounds, ou se não houver
 * nenhuma estação com coordenada válida. */
export const FALLBACK_CENTER = { lat: -20.3222, lng: -40.3378 };
export const FALLBACK_ZOOM = 12;

/**
 * Advanced Markers exigem um Map ID. `DEMO_MAP_ID` é o placeholder público da
 * Google pra prototipagem — funciona em qualquer projeto sem precisar criar
 * um Map ID customizado. Antes de ir pra produção, criar um Map ID de verdade
 * em Google Cloud Console → Maps → Map Management e trocar aqui.
 */
export const MAP_ID = 'DEMO_MAP_ID';

export const HOME_MAP_ID = 'bow-home-map';
